import { useState } from "react";
import {
  IoEllipsisHorizontal,
  IoSettingsOutline,
  IoTrashOutline,
} from "react-icons/io5";

import AccountChartHeader from "./components/AccountChartHeader";
import AccountChartTable from "./components/AccountChartTable";
import AccountChartForm from "./components/AccountChartForm";
import AccountChartDelete from "./components/AccountChartDelete";

import Dropdown from "../../../../components/common/Dropdown";
import Modal from "../../../../components/common/Modal";

const AccountCharts = () => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    type: "",
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const actions = (item) => {
    return [
      [
        {
          name: "Edit Info",
          icon: <IoSettingsOutline className="mr-3 text-gray-400" />,
          action: () => handleEdit(item),
          is_disabled: item.is_main,
        },
      ],
      [
        {
          name: "Delete Account Chart",
          icon: <IoTrashOutline className="mr-3 text-red-500" />,
          action: () => handleDelete(item),
          is_disabled: item.is_main,
        },
      ],
    ];
  };

  const columns = [
    { path: "name", label: "Name" },
    { path: "type_name", label: "Type" },
    { path: "number", label: "Number" },
    { path: "description", label: "Description" },
    {
      key: "actions",
      content: (data) => (
        <Dropdown items={actions(data)} icon={<IoEllipsisHorizontal />} />
      ),
    },
  ];

  const handleEdit = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowForm(!showForm);
  };

  const handleDelete = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowDelete(!showDelete);
  };

  const handleSuccess = (item) => {
    const index = data.findIndex((i) => i.id === item.id);

    if (index === -1) {
      setData([item, ...data]);
      return;
    }

    const items = [...data];
    items[index] = item;
    setData(items);
    setSelected(null);
  };

  const handleDeleteSuccess = (item) => {
    const charts = data.filter((i) => i.id !== item.id);
    setData(charts);
    handleDelete();
  };

  return (
    <div className="card">
      <AccountChartHeader
        options={tableOptions}
        onChange={setTableOptions}
        onSuccess={handleSuccess}
      />
      <AccountChartTable
        data={data}
        columns={columns}
        options={tableOptions}
        onChange={setTableOptions}
        setData={setData}
      />
      <Modal
        title="Update Account Chart"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={handleEdit}
        borderTop
      >
        <AccountChartForm
          data={selected}
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShowForm={setShowForm}
          onSuccess={handleSuccess}
        />
      </Modal>
      <Modal isLoading={isLoading} isOpen={showDelete} onClose={handleDelete}>
        <AccountChartDelete
          data={selected}
          setLoading={setIsLoading}
          onClose={handleDelete}
          onSuccess={handleDeleteSuccess}
        />
      </Modal>
    </div>
  );
};

export default AccountCharts;
